export default __webpack_public_path__ + "static/media/1969.90070259.png";